export const modes = Object.freeze([
    {
        id: 'sync',
        title: window.i18n.__('Synchronisé'),
    },
    {
        id: 'transfert',
        title: window.i18n.__('Transfert'),
    },
]);

export const providers = [
    {
        id: 'gmail',
        title: window.i18n.__('Gmail'),
        icon: 'svgGmail',
    },
    {
        id: 'office365',
        title: window.i18n.__('Office 365'),
        icon: 'office365',
    },
    {
        id: 'other',
        title: window.i18n.__('Autres'),
        icon: 'envelope',
    },
];
